/**
 * IR RAW→PRESET A/B player — the highest-converting asset.
 * Self-initialising, accessible, instant-play. Multiple instances per page are safe.
 * Switching RAW↔PRESET preserves the playhead and play state so the difference is
 * heard at the same moment in the take. No external deps; respects reduced-motion via CSS.
 */
(function () {
  if (window.__irAbpInit) return;
  window.__irAbpInit = true;

  var fmt = function (t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' + s : s);
  };

  function init(root) {
    if (root.dataset.abpInit) return;
    root.dataset.abpInit = '1';

    var audio = root.querySelector('audio');
    var playBtn = root.querySelector('.ir-abp__play');
    var segs = Array.prototype.slice.call(root.querySelectorAll('.ir-abp__seg'));
    var track = root.querySelector('.ir-abp__track');
    var fill = root.querySelector('.ir-abp__fill');
    var timeEl = root.querySelector('.ir-abp__time');
    var srcs = { before: root.dataset.before || '', after: root.dataset.after || '' };
    var mode = 'before';

    if (!audio || !srcs.before) return;
    audio.src = srcs.before;

    function setPlayIcon(playing) {
      root.classList.toggle('is-playing', playing);
      playBtn.setAttribute('aria-label', playing ? 'Pause' : 'Play');
      playBtn.setAttribute('aria-pressed', playing ? 'true' : 'false');
    }

    playBtn.addEventListener('click', function () {
      if (audio.paused) audio.play(); else audio.pause();
    });
    audio.addEventListener('play', function () { setPlayIcon(true); });
    audio.addEventListener('pause', function () { setPlayIcon(false); });
    audio.addEventListener('ended', function () { setPlayIcon(false); });

    function switchMode(next) {
      if (next === mode) return;
      var t = audio.currentTime;
      var wasPlaying = !audio.paused;
      mode = next;
      audio.src = srcs[mode];
      // Restore position once the new source is seekable.
      var restore = function () {
        try { audio.currentTime = t; } catch (e) {}
        if (wasPlaying) audio.play();
        audio.removeEventListener('loadedmetadata', restore);
      };
      audio.addEventListener('loadedmetadata', restore);
      audio.load();
      segs.forEach(function (b) {
        var on = b.dataset.mode === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }
    segs.forEach(function (b) {
      b.addEventListener('click', function () { switchMode(b.dataset.mode); });
    });

    function updateProgress() {
      var d = audio.duration || 0;
      var pct = d ? (audio.currentTime / d) * 100 : 0;
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(Math.round(pct)));
      if (timeEl) timeEl.textContent = fmt(audio.currentTime) + ' / ' + fmt(d);
    }
    audio.addEventListener('timeupdate', updateProgress);
    audio.addEventListener('loadedmetadata', updateProgress);

    function seekFromPointer(clientX) {
      var r = track.getBoundingClientRect();
      var ratio = Math.min(1, Math.max(0, (clientX - r.left) / r.width));
      if (audio.duration) audio.currentTime = ratio * audio.duration;
    }
    if (track) {
      track.addEventListener('click', function (e) { seekFromPointer(e.clientX); });
      track.addEventListener('keydown', function (e) {
        if (!audio.duration) return;
        var step = audio.duration * 0.05;
        if (e.key === 'ArrowRight') { audio.currentTime = Math.min(audio.duration, audio.currentTime + step); e.preventDefault(); }
        else if (e.key === 'ArrowLeft') { audio.currentTime = Math.max(0, audio.currentTime - step); e.preventDefault(); }
      });
    }
  }

  function initAll(ctx) {
    (ctx || document).querySelectorAll('.ir-abp').forEach(init);
  }

  if (document.readyState !== 'loading') initAll();
  else document.addEventListener('DOMContentLoaded', function () { initAll(); });

  // Theme editor: re-init when a section is re-rendered.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
